import React, { useContext } from "react";
import { withTranslation } from 'react-i18next';
import i18n from '../../../i18n';
import Clock from './../../../components/clock';
import ZmanTevilah from '../../../components/zman-tevilah';
import ClosingTime from '../../../components/closing-time';
import Shkia from '../../../components/shkia';
import Weather from './../../../components/snippets/weather';
import { SettingsContext } from './../../../components/context';

function ReceptionistHeader(props) {
  const { t } = props;
  const { settings } = useContext(SettingsContext);
  return <header className={"header reception-header lang-" + i18n.language + (props.halfScreenAtFull?" halfScreenAtFull":"")}>
    {settings && settings.testMode && settings.testMode.value==="True"?
      <div className="testMode">{t("System is currently in Test Mode")}</div>
    :null}
    <div>
      <div className="header-left row align-items-center">
        <img src={props.logo} className="logo" alt={props.logoImageAltText}/>
      </div>
      <div className="header-center">
        <Clock />
        <Clock type="fullDate" />
      </div>
      <div className="header-right row flex-xl-row-reverse align-items-end justify-content-xl-start justify-content-end">
        <Weather />
        <div className="">
        {settings && settings.erevYomKippurMode && settings.erevYomKippurMode.value==="True"?
          <div className="eykMode">{t("Erev Yom Kippur Mode")}</div>
        : 
        <>
          <Shkia />
          <ZmanTevilah />
          <ClosingTime />
        </>
        }
        </div>
      </div>
    </div>
  </header>
}

export default withTranslation()(ReceptionistHeader);